// Simulating API with filters, pagination, and sorting
{/*const now = new Date();

const jobs = [
  {
    id: 1,
    title: "Math Content Developer",
    company: "StrideNext Academy",
    companyLogo: "",
    yoe: "2-4 yrs",
    location: "Bengaluru",
    salary: "₹25,000 - ₹40,000",
    description: "Create and curate math lesson plans and assessment material for classes 6-10.",
    skills: ["Algebra", "Geometry", "Problem Solving"],
    postedBy: "Curriculum Team",
    postedAt: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days ago
    jobType: "Full-Time",
  },
  {
    id: 2,
    title: "Science Video Creator (Physics)",
    company: "StrideNext Academy",
    companyLogo: "",
    yoe: "1-3 yrs",
    location: "Chennai (Hybrid)",
    salary: "₹15,000 - ₹30,000",
    description: "Shoot and edit short explainer videos for physics topics aligned with state curriculum.",
    skills: ["Physics", "Video Editing", "Storyboarding"],
    postedBy: "Media Team",
    postedAt: new Date(now.getTime() - 18 * 60 * 60 * 1000).toISOString(), // 18 hours ago
    jobType: "Part-Time",
  },
  {
    id: 3,
    title: "Frontend Engineer - Educational UI",
    company: "StrideNext Labs",
    companyLogo: "",
    yoe: "3-5 yrs",
    location: "Remote",
    salary: "₹8 - 12 LPA",
    description: "Build interactive learning UIs and maintain the React codebase for our platform.",
    skills: ["React", "Accessibility", "Testing"],
    postedBy: "Engineering",
    postedAt: new Date(now.getTime() - 40 * 60 * 1000).toISOString(), // 40 minutes ago
    jobType: "Full-Time",
  },
  // add more items as needed...
];

export function fetchAllJobs() {
  // simulate async - we return a Promise to mimic an API
  return new Promise((res) => {
    setTimeout(() => res([...jobs]), 400);
  });
}

export function getJobById(id) {
  return new Promise((res) => {
    setTimeout(() => {
      const j = jobs.find((x) => x.id === Number(id));
      res(j || null);
    }, 300);
  });
}


// Simulate API delay
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchJobs = async (filters = {}, page = 1, limit = 6, sortBy = "datePosted") => {
  await delay(500); // simulate loading

  let filteredJobs = [...jobs];

  // Apply filters
  if (filters.search) {
    const searchLower = filters.search.toLowerCase();
    filteredJobs = filteredJobs.filter(
      (job) =>
        job.title.toLowerCase().includes(searchLower) ||
        job.company.toLowerCase().includes(searchLower)
    );
  }

  if (filters.location) {
    filteredJobs = filteredJobs.filter(
      (job) => job.location.toLowerCase() === filters.location.toLowerCase()
    );
  }

  if (filters.experience) {
    filteredJobs = filteredJobs.filter(
      (job) => job.yoe.includes(filters.experience)
    );
  }

  if (filters.jobType) {
    filteredJobs = filteredJobs.filter(
      (job) => job.jobType === filters.jobType
    );
  }

  // Sort
  if (sortBy === "datePosted") {
    filteredJobs.sort((a, b) => new Date(b.datePosted) - new Date(a.datePosted));
  } else if (sortBy === "yoe") {
    filteredJobs.sort((a, b) => {
      const aYoe = parseInt(a.yoe);
      const bYoe = parseInt(b.yoe);
      return bYoe - aYoe;
    });
  }

  // Pagination
  const startIndex = (page - 1) * limit;
  const endIndex = page * limit;
  const paginatedJobs = filteredJobs.slice(startIndex, endIndex);

  return {
    jobs: paginatedJobs,
    total: filteredJobs.length,
    totalPages: Math.ceil(filteredJobs.length / limit),
  };
};
*/}

import axios from "axios";

//const API_BASE = "http://127.0.0.1:8001"; // FastAPI backend URL
//const API_BASE = "http://144.91.102.67:8002"; // Production backend URL
const API_BASE = "https://api.stridenext.in"; // Use relative path for proxy setup in development and production
//const API_BASE = "http://localhost:8002"; // Production backend URL


// Utility: map frontend formData → backend API payload
{/*function mapToBackend(formData) {
  return {
    company_name: formData.companyName || formData.company,
    title: formData.role || formData.title,
    description: formData.description,
    skills: Array.isArray(formData.skills)
      ? formData.skills
      : (formData.skills || "").split(",").map((s) => s.trim()),
    job_type: formData.jobType || formData.type,
    department: formData.department || null,
    min_qualifications: formData.minQualification || null,
    preferred_skills: formData.preferredSkills
      ? formData.preferredSkills.split(",").map((s) => s.trim())
      : null,
    experience_years: formData.minExp || null,
    salary: formData.minSalary || formData.salary || null,
    salary_max: formData.maxSalary || null,
    location: formData.location,
    remote_option: formData.remote || false,
    company_logo: formData.companyLogo || "",
    company_website: formData.companyWebsite || "",
    status: "published",
  };
}*/}


{/*function mapToBackend(formData) {
  return {
    company_name: formData.companyName || formData.company,
    title: formData.role || formData.title,
    description: formData.description,
    skills: Array.isArray(formData.skills)
      ? formData.skills
      : (formData.skills || "")
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s !== ""),
    job_type: formData.jobType || formData.type || null,
    department: formData.department || null,
    min_qualifications: formData.minQualification || null,
    preferred_skills: formData.preferredSkills
      ? formData.preferredSkills.split(",").map((s) => s.trim())
      : null,
    experience_years: formData.minExp ? Number(formData.minExp) : null,
    salary: formData.minSalary ? Number(formData.minSalary) : null,
    salary_max: formData.maxSalary ? Number(formData.maxSalary) : null,
    location: formData.location || null,
    remote_option: Boolean(formData.remote),
    company_logo: formData.companyLogo || "",
    company_website: formData.companyWebsite || "",
    status: "published",
  };
}*/}

// added on 27-11-2025

// added on 27-11-2025
function mapToBackend(form) {
  return {
    jobTitle: form.jobTitle,
    jobType: form.jobType,
    category: form.category,
    location: form.location,
    description: form.description,
    requirements: form.requirements,
    skills: form.skills,
    qualifications: form.qualifications,
    salaryRange: form.salaryRange,
    experience: form.experience,
    openings: Number(form.openings),
    deadline: form.deadline,
    contactEmail: form.contactEmail,
    industry: form.category,
    application_questions: [],
  };
}

// Utility: map backend response → frontend job object
{/*function mapFromBackend(job) {
  return {
    id: job.job_id,
    title: job.title,
    company: job.company_name,
    companyLogo: job.company_logo,
    yoe: job.experience_years ? `${job.experience_years}+ yrs` : "N/A",
    location: job.location,
    salary: job.salary_max
      ? `${job.salary} - ${job.salary_max}`
      : job.salary || "Not specified",
    description: job.description,
    skills: job.skills || [],
    postedBy: "Recruiter", // backend doesn’t have this yet
    postedAt: job.created_at,
    jobType: job.job_type,
  };
} */}
// added on 3-12-2025
function mapFromBackend(job) {
  return {
    id: job.job_id,                          // backend sends "id"
    title: job.title,
    company: job.company_name,                // backend sends "company"
    companyLogo: job.company_logo || "",  // backend does NOT send logo
    yoe: job.experience || "N/A",        // backend sends no experience
    location: job.location,
    salary: job.salary ? `₹${job.salary}` : "Not specified",
    description: job.description || "",
    //requirements: .requirements || "",
    requirements: job.requirements || [],       // FIXED
    companyInfo: job.companyInfo || "",
    skills: job.skills || [],
    postedAt: job.created_at,                // backend sends "posted"
    jobType: job.jobType || "Full Time", // backend does NOT send job_type
  };  
}
// ✅ Fetch all jobs
export async function fetchAllJobs() {
  const res = await axios.get(`${API_BASE}/jobs`);
  return res.data.map(mapFromBackend);
}
// added on 3-12-2025
export async function getJobById(id) {
  const token = localStorage.getItem("access_token");
  const res = await axios.get(`${API_BASE}/api/jobs/${id}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

// ✅ Fetch single job by ID
{/*export async function getJobById(id) {
  const res = await axios.get(`${API_BASE}/jobs`);
  const job = res.data.find((j) => j.job_id === Number(id));
  return job ? mapFromBackend(job) : null;
}*/}

// ✅ Create new job
export async function addJob(formData) {
  const token = localStorage.getItem("access_token");
  const payload = mapToBackend(formData);
  const res = await axios.post(`${API_BASE}/jobs`, payload, {
    headers: { "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return mapFromBackend(res.data);
} 


// Apply Api 

export async function applyForJob(job_id) {
  const token = localStorage.getItem("access_token");

  const res = await axios.post(
    `${API_BASE}/api/apply`,
    { job_id },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
}


// More API functions (updateJob, deleteJob, etc.) can be added here as needed
export async function fetchCandidateApplications() {
  const token = localStorage.getItem("access_token");
  const res = await axios.get(`${API_BASE}/api/applications/me`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

// added on 27-11-2025
export async function fetchMyJobs() {
  const token = localStorage.getItem("access_token");
  const res = await axios.get(`${API_BASE}/api/jobs/my`,{
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}


// Recruiter Applications to see the candidate details


{/*export async function getRecruiterApplications() {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${API_BASE}/api/applications`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}*/}

// ============== Recruiter: get a single application detail ==============
export async function getApplicationDetail(appId) {
  const token = localStorage.getItem("access_token");
  const res = await axios.get(`${API_BASE}/api/applications/${appId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

// status api 

export async function updateApplicationStatus(id, status) {
  const token = localStorage.getItem("access_token");

  const res = await fetch(
    `http://144.91.102.67:8002/api/applications/${id}/status?status=${status}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error("Failed to update status");
  }

  return await res.json();
}


export async function getRecruiterApplications(jobId) {
  const token = localStorage.getItem("access_token");

  const res = await fetch(`http://144.91.102.67:8002/api/applications/job/${jobId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

 const data = await res.json();
  // ⭐ FIX HERE — ensure data is ALWAYS an array
  return Array.isArray(data) ? data : [];
}

// View count api end point 

export async function incrementJobView(jobId) {
  const token = localStorage.getItem("access_token");

  const res = await fetch(
    `http://144.91.102.67:8002/api/jobs/${jobId}/view`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error("Failed to increment job view");
  }

  return res.json();
}